export type SuggestionsPanelIntent = 'open' | 'toggle';

export type SuggestionsPanelVisibilityState = {
  isMobile: boolean;
  activeMainAreaView: string | null;
  activeView: string | null;
};

export type SuggestionsPanelVisibilityResult = {
  activeMainAreaView: string | null;
  activeView: string | null;
  shouldOpenDesktopSidebar: boolean;
  shouldCloseMobileSidebar: boolean;
};

export function getNextSuggestionsPanelVisibility(
  intent: SuggestionsPanelIntent,
  state: SuggestionsPanelVisibilityState
): SuggestionsPanelVisibilityResult {
  const showingMainArea = state.activeMainAreaView === 'suggestions';
  const showingSidebar = state.activeView === 'suggestions';

  if (intent === 'open') {
    if (showingMainArea || showingSidebar) {
      return {
        activeMainAreaView: state.activeMainAreaView,
        activeView: state.activeView,
        shouldOpenDesktopSidebar: false,
        shouldCloseMobileSidebar: false,
      };
    }
    if (state.isMobile) {
      return {
        activeMainAreaView: 'suggestions',
        activeView: null,
        shouldOpenDesktopSidebar: false,
        shouldCloseMobileSidebar: true,
      };
    }
    return {
      activeMainAreaView: null,
      activeView: 'suggestions',
      shouldOpenDesktopSidebar: true,
      shouldCloseMobileSidebar: false,
    };
  }

  if (state.isMobile) {
    return {
      activeMainAreaView: showingMainArea ? null : 'suggestions',
      activeView: null,
      shouldOpenDesktopSidebar: false,
      shouldCloseMobileSidebar: true,
    };
  }

  return {
    activeMainAreaView: null,
    activeView: showingSidebar ? null : 'suggestions',
    shouldOpenDesktopSidebar: !showingSidebar,
    shouldCloseMobileSidebar: false,
  };
}
